import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import '../../services/GlobalVariables'
import axios from 'axios'

const API_URL = global.SET_API_URL + 'reUsable/'

const initialState = {
    years: [],
    cmpData: [],
    isLoading: false,
    isError: false,
    isSuccess: false,
    message: ""
}

export const getYear = createAsyncThunk('ru/gil', async (_, thunkAPI) => {
    try {

        const result = await axios.get(API_URL + 'getYear')


        return result.data

    } catch (error) {

        const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString()

        return thunkAPI.rejectWithValue(message)

    }
})

export const getCompanyData = createAsyncThunk('ru/gcd', async (_, thunkAPI) => {
    try {
        const result = await axios.get(global.SET_API_URL + 'company/getcompany')
        return result.data
    } catch (error) {
        const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString()
        return thunkAPI.rejectWithValue(message)
    }
})

export const counterSalesSlice = createSlice({
    name: 'ru',
    initialState,
    reducers: {
        reset: (state) => {
            state.years = []
            state.cmpData = []
            state.isLoading = false
            state.isError = false
            state.isSuccess = false
            state.message = ""
        }

    },
    extraReducers: (builder) => {
        builder
            .addCase(getYear.pending, (state) => {
                state.isLoading = true
            })
            .addCase(getYear.fulfilled, (state, action) => {
                state.isLoading = false
                state.isSuccess = true
                state.years = action.payload
            })
            .addCase(getYear.rejected, (state, action) => {
                state.isLoading = false
                state.isError = true
                state.message = action.payload
            })
            .addCase(getCompanyData.pending, (state) => {
                state.isLoading = true
            })
            .addCase(getCompanyData.fulfilled, (state, action) => {
                state.isLoading = false
                state.isSuccess = true
                state.cmpData = action.payload
            })
            .addCase(getCompanyData.rejected, (state, action) => {
                state.isLoading = false
                state.isError = true
                state.message = action.payload
            })
    }
})

export const { reset } = counterSalesSlice.actions

export default counterSalesSlice.reducer